// ======================================================================
// File Name       : unsubmittedReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty } from '../utils';
import * as ActionTypes from '../constants/actionTypes/report';
import { RETURN_MAX_NUM } from '../constants';
import { REPORT_STATUS_NOT_SUBMITTED } from '../constants/KeyValueConstants';

const INITIAL_STATE = {
  unsubmittedReportList: {
    recordNum: 0,
    unsubmittedReportListResult: [],
    searchInfo: {
      reportStatusList: [REPORT_STATUS_NOT_SUBMITTED],
      includeDeadlineReportFlg: 0,
      reportHistorySortType: null, // default not sort
      ascendingDescendingSort: 0, // default value
      startPosition: 0, // default value
      returnMaxNum: RETURN_MAX_NUM, // default value
      groupName: '',
      userName: '',
      reportName: '',
    },
    groupList: [],
  },
};

export default function unsubmittedReport(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.UNSUBMITTED_REPORT_SEARCH: {
      const { reportListResult } = action;
      const { reportList, recordNum } = reportListResult;
      const unsubmittedReportList = {
        ...state.unsubmittedReportList,
        recordNum,
        unsubmittedReportListResult: reportList };
      return {
        ...state,
        unsubmittedReportList,
      };
    }
    case ActionTypes.UNSUBMITTED_REPORT_USER_LIST_SEARCH: {
      const { userList } = action;
      const userLists = userList && userList.reduce(
        (acc, cur) => {
          acc.byCd[cur.userSecernId] = cur;
          acc.allCds.push(cur.userSecernId);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      const { unsubmittedReportList } = state;
      const { unsubmittedReportListResult } = unsubmittedReportList;
      userLists && unsubmittedReportListResult && unsubmittedReportListResult.forEach((report) => {
        report.userName = '';
        if (userLists.byCd[report.submitterUserSecernId]) {
          report.userName = userLists.byCd[report.submitterUserSecernId].userName;
        }
      });
      return {
        ...state,
        unsubmittedReportList,
      };
    }
    case ActionTypes.UNSUBMITTED_REPORT_UPDATE_SEARCH_INFO: {
      const { searchInfo } = action;
      const unsubmittedReportList = {
        ...state.unsubmittedReportList,
        searchInfo };
      return {
        ...state,
        unsubmittedReportList,
      };
    }
    case ActionTypes.UNSUBMITTED_REPORT_GROUP_LIST: {
      const { groupList } = action;
      const unsubmittedReportList = {
        ...state.unsubmittedReportList,
        groupList };
      return {
        ...state,
        unsubmittedReportList,
      };
    }
    case ActionTypes.UNSUBMITTED_REPORT_RESET_INIT: {
      const { unsubmittedReportList } = INITIAL_STATE;
      if (unsubmittedReportList.searchInfo && unsubmittedReportList.searchInfo.selectedGroup) {
        delete unsubmittedReportList.searchInfo.selectedGroup;
      }
      if (unsubmittedReportList.searchInfo && unsubmittedReportList.searchInfo.groupName) {
        unsubmittedReportList.searchInfo.groupName = '';
      }
      return {
        ...state,
        unsubmittedReportList,
      };
    }
    default:
      return state;
  }
}
